module.exports = __webpack_public_path__ + "img/having-a-conversation.e16d2eb5.jpg";